<form [formGroup]="myGroup" id="myForm" novalidate (ngSubmit)="onSubmit($event)">
  <section id="content">

    <div class="spinner-container">
      <div class="spinner">
        <div class="sk-folding-cube">
          <div class="sk-cube1 sk-cube"></div>
          <div class="sk-cube2 sk-cube"></div>
          <div class="sk-cube4 sk-cube"></div>
          <div class="sk-cube3 sk-cube"></div>
        </div>
      </div>
    </div>

    <div class="external-tabs">
      <p-messages [escape]="true" [value]="msgs"></p-messages>
      <p-tabView [(activeIndex)]="index" (onChange)="onTabChange($event)">

        <p-tabPanel header="Cadence Info" leftIcon="pi pi-calendar">
          <div class="tab-content" [formGroup]="myGroup">
            <div role="tabpanel" class="tab-pane in active" id="tab-1">
              <div class="card">
                <div class="card-title">
                  <h2>Created By <span class="userLoginName">{{userLoginName}}</span> <span class="createdDate">{{"
                      "+createdDate}}</span></h2>
                </div><!-- /.card-title -->
                <div class="cont">
                  <div class="group">
                    <p-messages [escape]="true" [value]="msgs"></p-messages>
                    <div id="companyInfo" class="collapse-title"
                      (click)="ele.class = ele.class == 'showChildren' ? '' :  'showChildren'"
                      [ngClass]="{ hideChildren : ele.class !== 'showChildren' }">
                      Company Info
                      <i class="collapse-icon fa" [ngClass]="ele.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
                    </div>
                    <div class="collapse in show" id="group-1"
                      [ngClass]="{ hideChildren : ele.class !== 'showChildren' }" #ele>
                      <div class="group-cont opportunityData">

                        <div class="form-group">
                          <div class="row">
                            <div name="firstRow" class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select required formControlName="name" name="opportunitySource" id="opportunitySource"
                                  (change)="onDropDownChange($event)">
                                  <option id="-1" default="yes" [ngValue]="null" value="">Select</option>
                                  <option *ngFor="let status of sourceList; let i = index" [id]="status?.sourceId"
                                    [ngValue]="status" [value]="status?.sourceId">
                                    {{status?.source}}
                                  </option>
                                </select>
                                <label for="opportunitySource"><span class="required" style="color:coral">*
                                  </span>Source</label>
                                <label id="sourceId" style="margin-left: 14%;color: coral;"></label>
                              </div><!-- /.inputs -->
                              <div
                                *ngIf="myGroup.controls['name'].invalid && (myGroup.controls['name'].dirty || myGroup.controls['name'].touched)"
                                class="alert alert-danger">
                                <div *ngIf="myGroup.controls['name'].errors.required">
                                  Opportunity Source is required.
                                </div>
                              </div>
                            </div><!-- /.col-md-4 col-xs-12 -->

                            <div class="col-md-6 col-xs-12" *ngIf="displayPartnerName">
                              <div id="partenerText" class="inputs">
                                <input type="text" required="false" formControlName="partenerName" name="partenerName"
                                  id="partenerName" [(ngModel)]="opportunitiesDTO.partenerName" />
                                <label for="partenerName">Partner Name</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->

                            <div name="firstRow" class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <!-- <select name="customerNumber" required [(ngModel)]="opportunitiesDTO.customer.customerId" formControlName="customerNumber" id="customerNumber">
                                      <option id="-1" selected default="yes" [ngValue]="null" value="Select">Select
                                      </option>
                                      <option *ngFor="let status of customerList; let i = index"
                                        [id]="status?.customerId" [value]="status?.customerId">
                                        {{status?.customerNumber + " - " + status?.customerName}}
                                      </option>
                                    </select> -->
                                <!-- <p-dropdown [options]="customerList" class="full-width" optionLabel="customerName"
                                  filter="true" name="customerNumber" required [(ngModel)]="opportunitiesDTO.customer"
                                  formControlName="customerNumber" id="customerNumber" placeholder="Select Customer"
                                  [showClear]="true">
                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.customerId}}">{{option.customerNumber + ' - ' +
                                      option.customerName}}</span>
                                  </ng-template>
                                  
                                </p-dropdown> -->

                                <p-dropdown [options]="customerList" class="full-width" optionLabel="customerName"
                                  optionValue="customerId" filter="true" name="customerNumber" required
                                  [(ngModel)]="opportunitiesDTO.customer" formControlName="customerNumber"
                                  id="customerNumber" placeholder="Select Customer" [showClear]="true"
                                  filterBy="customerNumber,customerName"
                                  [virtualScroll]="true" [virtualScrollItemSize]="38" [lazy]="true">

                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.customerId}}">{{option.customerNumber + ' - ' +
                                      option.customerName}}</span>
                                  </ng-template>
                                </p-dropdown>


                                <!--                                                             <input type="text" id="customerNumber" readonly value="1019144052" /> -->
                                <label for="customerNumber"><span class="required" style="color:coral">*
                                  </span>Customer Number - Customer Name</label>
                                <label id="customerId" style="margin-left: 42%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['customerNumber'].invalid && (myGroup.controls['customerNumber'].dirty || myGroup.controls['customerNumber'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['customerNumber'].errors.required">Customer Number -
                                    Customer Name is required.</div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-4 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-4 col-xs-12">
                              <div class="inputs ui-grid-col-12">

                                <!-- <p-dropdown [options]="salesReps" optionLabel="value" filter="true"  name="salesRep" [(ngModel)]="opportunitiesDTO.salesRep" formControlName="salesRep" id="salesRep" 
                                        placeholder="Select.." [showClear]="true" [autoWidth]="false" class="full-width" >
                                      <ng-template let-option pTemplate="item">
                                        <span id="{{option.id}}">{{option.name}}</span>
                                      </ng-template>
                                    </p-dropdown> -->

                                <p-dropdown [options]="salesReps" optionLabel="name" optionValue="name" filter="true"
                                  name="salesRep" [(ngModel)]="opportunitiesDTO.salesRep" formControlName="salesRep"
                                  id="salesRep" placeholder="Select.." [showClear]="true" [autoWidth]="false"
                                  class="full-width">
                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.name}}">{{option.name}}</span>
                                  </ng-template>
                                </p-dropdown>

                                <label for="salesRep">Sales Rep</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-4 col-xs-12">
                              <div class="inputs">

                                <p-dropdown [options]="salesUsers" class="full-width" optionLabel="lastName"
                                  filter="true" name="sssOwnerName" required [(ngModel)]="opportunitiesDTO.sssOwnerName"
                                  formControlName="sssOwnerName" id="sssOwnerName" placeholder="Select..."
                                  filterBy="firstName,lastName"
                                  [showClear]="true">
                                  <ng-template let-option pTemplate="selectedItem">
                                    <div class="item">
                                      <div>{{option.firstName + " " + option.lastName}}</div>
                                    </div>
                                  </ng-template>
                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.firstName + ' ' + option.lastName}}">{{option.firstName + " " +
                                      option.lastName}}</span>
                                  </ng-template>
                                </p-dropdown>

                                <label for="sssOwnerName"><span class="required" style="color:coral">* </span>SSS Owner
                                  Name</label>
                                <label id="ownerId" style="margin-left: 34%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['sssOwnerName'].invalid && (myGroup.controls['sssOwnerName'].dirty || myGroup.controls['sssOwnerName'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['sssOwnerName'].errors.required">SSS Owner Name is
                                    required.</div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-2 col-xs-12">
                              <div class="inputs-select">
                                <div class="input-checkbox">
                                  <input type="checkbox" name="" id="confidential"
                                    [(ngModel)]="opportunitiesDTO.confidential" [ngModelOptions]="{standalone: true}" />
                                  <span></span>
                                </div><!-- /.input-checkbox -->
                                <label for="confidential">Confidential</label>
                              </div><!-- /.inputs -->
                            </div>
                            <div class="col-md-2 col-xs-12">
                              <div class="inputs-select">
                                <div class="input-checkbox">
                                  <input type="checkbox" name="" id="renewable" [(ngModel)]="opportunitiesDTO.renewable"
                                    [ngModelOptions]="{standalone: true}" />
                                  <span></span>
                                </div><!-- /.input-checkbox -->
                                <label for="renewable">Renewal</label>
                              </div><!-- /.inputs -->
                            </div>
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->

                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select name="sector" required formControlName="sector" class="sector" id="sector">
                                  <option [ngValue]="null" id="-1" selected default="yes" value="Select">Select
                                  </option>
                                  <option *ngFor="let sector of sectors; let i = index" [id]="sector?.sectorId"
                                    [value]="sector?.sectorId">
                                    {{sector?.sector}}
                                  </option>
                                </select>
                                <label for="sector"><span class="required" style="color:coral">*
                                  </span>Sector</label>
                                <label id="sectorId" style="margin-left: 10%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['sector'].invalid && (myGroup.controls['sector'].dirty || myGroup.controls['sector'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['sector'].errors.required">
                                    Sector is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select name="region" required formControlName="region" class="region" id="region">
                                  <option [ngValue]="null" id="-1" selected default="yes" value="Select">Select
                                  </option>
                                  <option *ngFor="let region of regionsList; let i = index" [id]="region?.regionId"
                                    [value]="region?.regionId">
                                    {{region?.region}}
                                  </option>
                                </select>
                                <label for="region"><span class="required" style="color:coral">*
                                  </span>Region</label>
                                <label id="regionId" style="margin-left: 10%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['region'].invalid && (myGroup.controls['region'].dirty || myGroup.controls['region'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['region'].errors.required">
                                    Region is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->

                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" name="" id="ommsysNumber" [(ngModel)]="opportunitiesDTO.ommsysNumber"
                                  [ngModelOptions]="{standalone: true}" />
                                <label for="ommsysNumber">OMSYS Number</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" required id="opportunityName" formControlName="oppName"
                                  (change)="onInputChange($event);" />
                                <label for="opportunityName"><span class="required" style="color:coral">*
                                  </span>Opportunity Name</label>
                                <label id="opportunityNameErr" style="margin-left: 24%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['oppName'].invalid && (myGroup.controls['oppName'].dirty || myGroup.controls['oppName'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['oppName'].errors.required">
                                    Opportunity Name is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-12">
                              <div class="inputs">
                                <textarea required formControlName="description" id="description" maxlength="250"
                                  cols="30" [(ngModel)]="opportunitiesDTO.description" rows="10"></textarea>
                                <label for="description">Opportunity Description <span class="required"
                                    style="color:coral">*
                                  </span></label>
                                <div
                                  *ngIf="myGroup.controls['description'].invalid && (myGroup.controls['description'].dirty || myGroup.controls['description'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['description'].errors.required">
                                    Opportunity description is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select name="status" required formControlName="status" class="status" id="status"
                                  (change)="onDropDownChange($event)">
                                  <option id="-1" [ngValue]="null" selected default="yes" value="Select">Select
                                  </option>
                                  <option *ngFor="let status of statusList; let i = index" class="status?.odds"
                                    [id]="status?.odds" [value]="status?.statusId">
                                    {{status?.status}}
                                  </option>
                                </select>
                                <label for="status"><span class="required" style="color:coral">*
                                  </span>Status</label>
                                <label id="statusId" style="margin-left: 10%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['status'].invalid && (myGroup.controls['status'].dirty || myGroup.controls['status'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['status'].errors.required">
                                    Status is required.
                                  </div>
                                </div>
                                <div *ngIf="(myGroup.controls['status'].value == 5)" class="alert alert-warning">
                                  when status is won, you need to upload attachments .
                                </div>

                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="odds" name="" disabled>
                                <label for="odds">ODDs</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <!-- <input class="datepicker" type="text" value=""  [(ngModel)]="opportunitiesDTO.expectedClosingDate" [ngModelOptions]="{standalone: true}"
                                                        id="expectedClosingDate"> -->
                                <p-calendar rquired class="datepicker" required id="expectedClosingDate"
                                  [(ngModel)]="opportunitiesDTO.expectedClosingDate" class="full-width"
                                  formControlName="expectedClosingDate" dateFormat="yy-mm-dd" showButtonBar="true"
                                  [showIcon]="true"></p-calendar>

                                <label for="expectedClosingDate"><span class="required" style="color:coral">*
                                  </span>Expected Closing Date</label>
                                <label id="closingDate" style="margin-left: 24%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['expectedClosingDate'].invalid && (myGroup.controls['expectedClosingDate'].dirty || myGroup.controls['expectedClosingDate'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['expectedClosingDate'].errors.required">
                                    Closing Date is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <!-- <input class="datepicker" type="text" value=""  [(ngModel)]="opportunitiesDTO.customerTiming" [ngModelOptions]="{standalone: true}" id="customerTiming"> -->
                                <p-calendar class="datepicker" id="customerTiming" class="full-width"
                                  [(ngModel)]="opportunitiesDTO.customerTiming" [ngModelOptions]="{standalone: true}"
                                  dateFormat="yy-mm-dd" showButtonBar="true" [showIcon]="true"></p-calendar>

                                <label for="customerTiming">Customer Timing</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="so" [(ngModel)]="opportunitiesDTO.so"
                                  [ngModelOptions]="{standalone: true}">
                                <label for="so">SO#</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <!-- <input class="datepicker" type="text" value="" id="dueDate"  [(ngModel)]="opportunitiesDTO.dueDate" [ngModelOptions]="{standalone: true}"> -->
                                <p-calendar class="datepicker" id="dueDate" [(ngModel)]="opportunitiesDTO.dueDate"
                                  class="full-width" [ngModelOptions]="{standalone: true}" dateFormat="yy-mm-dd"
                                  showButtonBar="true" [showIcon]="true"></p-calendar>

                                <label for="dueDate">Cancellation or Winning or Losing Date</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="customerBudget" (keyup)="Comma($event)" value="0"
                                  [(ngModel)]="opportunitiesDTO.customerBudget" [ngModelOptions]="{standalone: true}">
                                <label for="customerBudget">Customer Budget</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="contactName" [(ngModel)]="opportunitiesDTO.contactName"
                                  [ngModelOptions]="{standalone: true}">
                                <label for="contactName">Contact Name</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="customerAuth" [(ngModel)]="opportunitiesDTO.customerAuth"
                                  [ngModelOptions]="{standalone: true}">
                                <label for="customerAuth">Customer Authority</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select name="customerNeed" required formControlName="customerNeed" class="customerNeed"
                                  id="customerNeed" (change)="onDropDownChange($event)">
                                  <option [ngValue]="null" id="-1" selected default="yes" value="Select">Select
                                  </option>
                                  <option *ngFor="let status of customerNeedList; let i = index"
                                    [id]="status?.customerId" [value]="status?.customerId">
                                    {{status?.customerNeed}}
                                  </option>
                                </select>
                                <label for="customerNeed"><span class="required" style="color:coral">*
                                  </span>Customer Need</label>
                                <label id="customerNeedId" style="margin-left: 20%;color: coral;"></label>
                                <div
                                  *ngIf="myGroup.controls['customerNeed'].invalid && (myGroup.controls['customerNeed'].dirty || myGroup.controls['customerNeed'].touched)"
                                  class="alert alert-danger">
                                  <div *ngIf="myGroup.controls['customerNeed'].errors.required">
                                    CustomerNeed is required.
                                  </div>
                                </div>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <input type="text" #bussPartner id="businessPartners"
                                  [(ngModel)]="opportunitiesDTO.businessPartners" [ngModelOptions]="{standalone: true}">
                                <label for="businessPartners">Business Partners</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-xs-12">
                              <div class="inputs">
                                <select name="sbmchannel" id="sbmchannel" [(ngModel)]="opportunitiesDTO.sbmchannel"
                                  [ngModelOptions]="{standalone: true}" (change)="onDropDownChange($event)">
                                  <option value="">Select</option>
                                  <option value="SBM CSS">SBM CSS</option>
                                  <option value="SBM NSS">SBM NSS</option>
                                </select>
                                <label for="sbmchannel">SBM As A Channel</label>
                                <label id="sbmchannelId" style="margin-left: 20%;color: coral;"></label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-2 col-xs-12">
                              <div class="inputs-select">
                                <div class="input-checkbox">
                                  <input type="checkbox" name="" id="sbo" [(ngModel)]="opportunitiesDTO.sbo"
                                    [ngModelOptions]="{standalone: true}" />
                                  <span></span>
                                </div><!-- /.input-checkbox -->
                                <label for="sbo">SBO</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                            <div class="col-md-4 col-xs-12">
                              <div class="inputs">
                                <input type="text" id="sboNumber" [(ngModel)]="opportunitiesDTO.sboNumber"
                                  [ngModelOptions]="{standalone: true}">
                                <label for="sboNumber">SBO Number</label>
                              </div><!-- /.inputs -->
                            </div><!-- /.col-md-6 col-xs-12 -->
                          </div><!-- /.row -->
                        </div><!-- /.form-group -->
                      </div><!-- /.group-cont -->
                    </div>
                  </div><!-- /.group -->
                  <div class="group">
                    <div class="collapse-title"
                      (click)="ele2.class = ele2.class == 'showChildren' ? '' :  'showChildren'"
                      [ngClass]="{ hideChildren : ele2.class !== 'showChildren' }">
                      Attachments
                      <i class="collapse-icon fa"
                        [ngClass]=" ele2.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
                    </div>
                    <p-messages [escape]="true" [value]="msgs"></p-messages>
                    <div class="collapse in show" id="group-2"
                      [ngClass]="{ hideChildren : ele2.class !== 'showChildren' }" #ele2>
                      <div class="group-cont">
                        <div class="input-attachment">
                          <ul class="attaches" id="opportunityAttachments">
                            <div id="{{file.attachmentId}}" *ngFor="let file of attachmentFiles; let i = index">
                              <li id="{{file.attachmentId}}" class="{{file.attachmentName}}"
                                (click)="downloadAttachment($event)">
                                {{file.attachmentName}}
                                <div class="icon"><i class="la la-paperclip"></i></div>
                              </li>
                              <li style="background-color:white;border:none;">
                                <div class="delete text-red">
                                  <i class="la la-trash" id="{{file.attachmentId}}" title="{{file.attachmentName}}"
                                    (click)="deleteAttachment($event);"></i>
                                </div>
                              </li>
                            </div>

                          </ul>
                          <div class="input" style="height: auto;">
                            <!--  <input type="file" #fileUpload name="" id="addAttach" (change)="onUpload($event)">
                                           <label for="">
                                                <div class="icon">
                                                    <svg height="512pt" viewBox="0 0 512 512" width="512pt"
                                                        xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="m354 60c0-33.085938-26.914062-60-60-60h-234c-33.085938 0-60 26.914062-60 60v234c0 33.085938 26.914062 60 60 60h96v40h40v-40h98c33.085938 0 60-26.914062 60-60v-96h39v-40h-39zm-40 234c0 11.027344-8.972656 20-20 20h-234c-11.027344 0-20-8.972656-20-20v-234c0-11.027344 8.972656-20 20-20h234c11.027344 0 20 8.972656 20 20zm158 138h40v40c0 22.089844-17.910156 40-40 40h-39v-40h39zm-199 40h40v40h-40zm80 0h40v40h-40zm159-274v40h-40v-40h-39v-40h39c22.089844 0 40 17.910156 40 40zm-40 78h40v40h-40zm0 78h40v40h-40zm-276 118h39v40h-39c-22.089844 0-40-17.910156-40-40v-40h40zm37-318h40v120h-120v-40h51.714844l-71.359375-71.359375 28.285156-28.28125 71.359375 71.355469zm0 0" />
                                                        </svg>
                                                </div>
                                                Click To Add Or Drop Files Here
                                            </label>
                                            <button mat-button color="warn" (click)="onUpload($event)">                                                   
                                                Upload  
                                            </button>  -->
                            <p-fileUpload name="demo[]" #fileUpload customUpload="true"
                              (onUpload)="onUpload($event,fileUpload)" (uploadHandler)="onUpload($event, fileUpload)"
                              multiple="multiple" maxFileSize="1000000">
                              <!-- <ng-template pTemplate="content">
                                                <ul *ngIf="uploadedFiles.length">
                                                    <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
                                                </ul>
                                            </ng-template>-->
                            </p-fileUpload>

                          </div>
                        </div>
                      </div><!-- /.group-cont -->
                    </div>
                  </div><!-- /.group -->
                </div><!-- /.card-cont -->
              </div><!-- /.card -->
              <div class="wizard-cotroles">
                <div class="control next" (click)="openNext(1)">Next</div>
                <p>1 Of 5</p>
                <!-- <div class="control prev">Prev</div> -->
              </div>
            </div>
          </div>

        </p-tabPanel>

        <p-tabPanel header="Products" leftIcon="pi pi-inbox" *ngIf="hasSWG || hasSTG">
          <div role="tabpanel" class="tab-pane" id="tab-2">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="cont">
                  <div class="group" id="swgopp">
                    <div class="card primary">
                      <!--                                         <div class="card-title"> -->
                      <!--                                         </div> -->
                      <!--/.card-title -->
                      <div class="collapse-title" #opportunityTypeEle id="oppType"
                        (click)="swgTab.class = 'showChildren'; onOppyClick(swgTab);">
                        <h2>Opportunity Type

                        </h2>
                      </div> <!-- /.collapse-title -->

                      <div class="collapse in show" id="group-1-0" [ngClass]="{ hideChildren : false }" #swgTab>
                        <div class="group-cont">
                          <div class="form-group">
                            <div class="inputs">
                              <form>
                                <input type="radio" name="sltype" id="collapseOne"
                                  (click)="onOpportunitySelect($event);" value="License and Service"> License
                                and Service <br> <br>
                                <input type="radio" name="sltype" id="collapseTwo"
                                  (click)="onOpportunitySelect($event);" value="Service Only">
                                Service Only
                                <br> <br>
                                <input type="radio" name="sltype" id="collapseThree"
                                  (click)="onOpportunitySelect($event);" value="License Only">
                                License Only
                                <br>
                              </form>
                            </div><!-- /.inputs -->
                          </div> <!-- /.form-group -->
                        </div> <!-- /.group-cont -->
                      </div> <!-- /.collapse in -->
                    </div><!-- /.cont -->
                  </div> <!-- group-->
                </div><!-- /.col-md-4 col-sm-6 col-xs-12 -->
              </div> <!-- /.card primary -->

              <div class="col-md-4 col-sm-6 col-xs-12" *ngIf="licenseAndServiceOnly || serviceOnly">
                <div class="cont">
                  <div class="group">
                    <div class="card primary">
                      <div class="collapse-title" #techLeadEle id="techLead">
                        <h2>Service Details

                        </h2>
                      </div> <!-- /.collapse-title -->

                      <div class="collapse in show" id="group-2-0" #techLeadTab>
                        <div class="group-cont">
                          <div class="form-group">
                            <label style=" display: inline-block;margin-bottom: 0.5rem;">Technical Lead:</label>
                            <p-dropdown [options]="techLeads" optionLabel="lastName" filter="true" name="techLead"
                              class="full-width" [(ngModel)]="opportunitiesDTO.techLead" formControlName="techLead"
                              id="techLead" placeholder="Select..." [showClear]="true">
                              <ng-template let-option pTemplate="selectedItem">
                                <div class="item">
                                  <div>{{option.firstName + " " + option.lastName}}</div>
                                </div>
                              </ng-template>
                              <ng-template let-option pTemplate="item">
                                <span id="{{option.userId}}">{{option.firstName + " " + option.lastName}}</span>
                              </ng-template>
                            </p-dropdown>
                          </div> <!-- /.form-group -->
                        </div> <!-- /.group-cont -->
                      </div> <!-- /.collapse in -->
                    </div><!-- /.cont -->
                  </div> <!-- group-->
                </div><!-- /.col-md-4 col-sm-6 col-xs-12 -->
              </div> <!-- /.card primary -->

              <div class="col-md-12 col-sm-6 col-xs-12">
                <div class="group" id="group-1-3">
                  <div class="card">
                    <div class="card-title" style=" margin-bottom: 0;">
                      <h3>Products:</h3>
                    </div> <!-- /.card-title -->
                    <div>

                      <div>
                        <div class="group" id="group-1-3">
                          <div>

                            <div>

                              <p-toolbar styleClass="p-mb-4">
                                <div class="ui-toolbar-group-left">

                                  <p-button (click)="openNew()" icon="pi pi-plus" label="add" type="button"
                                    style="margin-right: 5px;"></p-button>
                                  
                                    <!-- to solve the delete problem -->

                                  <p-button (click)="deleteSelectedProducts()" type="button" icon="pi pi-trash"
                                    label="Delete"
                                    [disabled]="!selectedProducts || !selectedProducts.length"></p-button>

                                </div>

                                <div class="ui-toolbar-group-right">

                                </div>
                              </p-toolbar>

                              <p-table #dt [value]="products" [rows]="10" [paginator]="true" [globalFilterFields]="[
                                      'category.category',
                                      'productType.productType',
                                      'item.item',
                                      'orderPrice'
                                    ]" [(selection)]="selectedProducts" [rowHover]="true" dataKey="rowIndex"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">
                                <ng-template pTemplate="caption">
                                  <div class="p-d-flex p-ai-center p-jc-between">
                                    <h5 class="p-m-0">Manage Products</h5>
                                    <span class="p-input-icon-left">
                                      <i class="pi pi-search"></i>
                                      <input pInputText type="text"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Search..." />
                                    </span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                  <tr>
                                    <th style="width: 3rem">
                                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th pSortableColumn="category.category">
                                      Category <p-sortIcon field="category.category"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="productType.productType">
                                      Type <p-sortIcon field="productType.productType"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="item.item">
                                      Item <p-sortIcon field="item.item"></p-sortIcon>
                                    </th>
                                    <!-- <th pSortableColumn="rating">
                                          Reviews <p-sortIcon field="rating"></p-sortIcon>
                                        </th> -->
                                    <th pSortableColumn="orderPrice">
                                      price <p-sortIcon field="orderPrice"></p-sortIcon>
                                    </th>
                                    <th>
                                      Actions
                                    </th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                  <tr>
                                    <td>
                                      <p-tableCheckbox [value]="product"></p-tableCheckbox>
                                    </td>
                                    <td>{{ product.category.category }}</td>
                                    <td>{{ product.productType.productType }}</td>
                                    <td>{{ product.item.item }}</td>

                                    <td>{{ product.orderPrice.toLocaleString()}} $</td>
                                    <td>
                                      <button style="margin-right: 3px;" pButton pRipple icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success p-mr-2"
                                        (click)="editProduct(product, rowIndex)" type="button"></button>
                                      <button pButton pRipple icon="pi pi-trash"
                                        class="p-button-rounded p-button-warning"
                                        (click)="deleteProduct(product, rowIndex)" type="button" ></button>
                                    </td>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                  <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are {{ products ? products.length : 0 }} Products.
                                  </div>
                                </ng-template>
                              </p-table>
                            </div>
                          </div> <!-- /.card -->
                        </div> <!-- /.group -->
                      </div> <!-- /.col -->

                    </div>
                  </div> <!-- /.card -->
                </div> <!-- /.group -->
              </div> <!-- /.col -->

            </div><!-- /.row-->




            <div class="group" id="swnlv">





              <div class="wizard-cotroles">
                <div class="control next" data-target="tab-3" (click)="openNext(2)">Next</div>
                <p>2 Of 3</p>
                <div class="control prev" data-target="tab-1" (click)="openPrevious(0)">Prev</div>
              </div> <!-- /.wizard-cotroles -->
            </div> <!-- /.tab-pane -->
          </div>
        </p-tabPanel>
        <p-tabPanel header="STG" leftIcon="pi pi-folder" *ngIf="hasSTG && false">
          <div class="tab-pane in" id="tab-3" role="tabpanel">
            <div class="row">
              <div class="col-md-4 col-sm-6 col-xs-12">
                <div class="cont">
                  <div class="group" id="stgopp">
                    <div class="card primary">
                      <!--                                         <div class="card-title"> -->
                      <!--                                         </div> -->
                      <!--/.card-title -->
                      <div class="collapse-title" #stgOpportunityTypeEle id="stgoppType"
                        (click)="stgTab.class = (stgTab.class == 'showChildren' ? '' :  'showChildren'); onOppyClick(stgTab);"
                        [ngClass]="{ hideChildren : stgTab.class !== 'showChildren' }">
                        <h2>Opportunity Type
                          <i class="collapse-icon fa"
                            [ngClass]=" stgTab.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
                        </h2>
                      </div> <!-- /.collapse-title -->

                      <div class="collapse in show" id="group-7-0"
                        [ngClass]="{ hideChildren : stgTab.class !== 'showChildren' }" #stgTab>
                        <div class="group-cont">
                          <div class="form-group">
                            <div class="inputs">
                              <form>
                                <input type="radio" name="hwtype" id="collapse2-1"
                                  (click)="onSTGOpportunitySelect($event);" href="#collapse2-1"> Hardware and
                                Service <br> <br>
                                <input type="radio" name="hwtype" id="collapse2-2"
                                  (click)="onSTGOpportunitySelect($event);" href="#collapse2-2"> Hardware Only <br>
                                <br>
                                <input type="radio" name="hwtype" id="collapse2-3"
                                  (click)="onSTGOpportunitySelect($event);" href="#collapse2-3"> Service Only <br>
                              </form>
                            </div><!-- /.inputs -->
                          </div> <!-- /.form-group -->
                        </div> <!-- /.group-cont -->
                      </div> <!-- /.collapse in -->
                    </div><!-- /.cont -->
                  </div> <!-- group-->
                </div><!-- /.col-md-4 col-sm-6 col-xs-12 -->

              </div><!-- /.card primary -->

              <div class="col-md-4 col-sm-6 col-xs-12" *ngIf="stglicenseAndServiceOnly ||stgserviceOnly">
                <div class="cont">
                  <div class="group">
                    <div class="card primary">
                      <div class="collapse-title" #techLeadEle id="techLead"
                        (click)="techLeadTab.class = (techLeadTab.class == 'showChildren' ? '' : 'showChildren');"
                        [ngClass]="{ hideChildren: techLeadTab.class !== 'showChildren' }">
                        <h2>Service Details
                          <i class="collapse-icon fa"
                            [ngClass]="techLeadTab.class !== 'showChildren' ? 'fa-plus' : 'fa-minus'"></i>
                        </h2>
                      </div> <!-- /.collapse-title -->

                      <div class="collapse in show" id="group-2-0"
                        [ngClass]="{ hideChildren: techLeadTab.class !== 'showChildren' }" #techLeadTab>
                        <div class="group-cont">
                          <div class="form-group">
                            <label style=" display: inline-block;margin-bottom: 0.5rem;">Technical Lead:</label>
                            <p-dropdown [options]="techLeads" optionLabel="lastName" optionValue="userId" filter="true"
                              name="techLead" class="full-width" [(ngModel)]="opportunitiesDTO.techLead"
                              formControlName="techLead" id="techLead" placeholder="Select..." [showClear]="true">
                              <ng-template let-option pTemplate="selectedItem">
                                <div class="item">
                                  <div>{{option.firstName + " " + option.lastName}}</div>
                                </div>
                              </ng-template>
                              <ng-template let-option pTemplate="item">
                                <span id="{{option.userId}}">{{option.firstName + " " + option.lastName}}</span>
                              </ng-template>
                            </p-dropdown>
                          </div> <!-- /.form-group -->
                        </div> <!-- /.group-cont -->
                      </div> <!-- /.collapse in -->
                    </div><!-- /.cont -->
                  </div> <!-- group-->
                </div><!-- /.col-md-4 col-sm-6 col-xs-12 -->
              </div> <!-- /.card primary -->


              <div class="col-md-12 col-sm-6 col-xs-12">
                <div class="group" id="group-1-3">
                  <div class="card">
                    <div class="card-title" style=" margin-bottom: 0;">
                      <h3>Products:</h3>
                    </div> <!-- /.card-title -->
                    <div>

                      <div>
                        <div class="group" id="group-1-3">
                          <div>

                            <div>

                              <p-toolbar styleClass="p-mb-4">
                                <div class="ui-toolbar-group-left">

                                  <p-button (click)="openNew()" icon="pi pi-plus" label="add" type="button"
                                    style="margin-right: 5px;"></p-button>
                                  <p-button (click)="deleteSelectedProducts()" type="button" icon="pi pi-trash"
                                    label="Delete"
                                    [disabled]="!selectedProducts || !selectedProducts.length"></p-button>

                                </div>

                                <div class="ui-toolbar-group-right">

                                </div>
                              </p-toolbar>

                              <p-table #dt [value]="products" [rows]="10" [paginator]="true" [globalFilterFields]="[
                                      'category.category',
                                      'productType.productType',
                                      'item.item',
                                      'orderPrice'
                                    ]" [(selection)]="selectedProducts" [rowHover]="true" dataKey="rowIndex"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                [showCurrentPageReport]="true">
                                <ng-template pTemplate="caption">
                                  <div class="p-d-flex p-ai-center p-jc-between">
                                    <h5 class="p-m-0">Manage Products</h5>
                                    <span class="p-input-icon-left">
                                      <i class="pi pi-search"></i>
                                      <input pInputText type="text"
                                        (input)="dt.filterGlobal($event.target.value, 'contains')"
                                        placeholder="Search..." />
                                    </span>
                                  </div>
                                </ng-template>
                                <ng-template pTemplate="header">
                                  <tr>
                                    <th style="width: 3rem">
                                      <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                    </th>
                                    <th pSortableColumn="category.category">
                                      Category <p-sortIcon field="category.category"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="productType.productType">
                                      Type <p-sortIcon field="productType.productType"></p-sortIcon>
                                    </th>
                                    <th pSortableColumn="item.item">
                                      Item <p-sortIcon field="item.item"></p-sortIcon>
                                    </th>
                                    <!-- <th pSortableColumn="rating">
                                          Reviews <p-sortIcon field="rating"></p-sortIcon>
                                        </th> -->
                                    <th pSortableColumn="orderPrice">
                                      price <p-sortIcon field="orderPrice"></p-sortIcon>
                                    </th>
                                    <th>
                                      Actions
                                    </th>
                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                                  <tr>
                                    <td>
                                      <p-tableCheckbox [value]="product"></p-tableCheckbox>
                                    </td>
                                    <td>{{ product.category.category }}</td>
                                    <td>{{ product.productType.productType }}</td>
                                    <td>{{ product.item.item }}</td>

                                    <td>{{ product.orderPrice.toLocaleString()}} $</td>
                                    <td>
                                      <button style="margin-right: 3px;" pButton pRipple icon="pi pi-pencil"
                                        class="p-button-rounded p-button-success p-mr-2"
                                        (click)="editProduct(product, rowIndex)" type="button"></button>
                                      <button pButton pRipple icon="pi pi-trash" [disabled]="product.orderId != 0"
                                        class="p-button-rounded p-button-warning"
                                        (click)="deleteProduct(product, rowIndex)" type="button"></button>
                                    </td>

                                  </tr>
                                </ng-template>
                                <ng-template pTemplate="summary">
                                  <div class="p-d-flex p-ai-center p-jc-between">
                                    In total there are {{ products ? products.length : 0 }} Products.
                                  </div>


                                </ng-template>
                              </p-table>

                          
                            </div>
                          </div> <!-- /.card -->
                        </div> <!-- /.group -->
                      </div> <!-- /.col -->

                    </div>
                  </div> <!-- /.card -->
                </div> <!-- /.group -->
              </div> <!-- /.col -->



            </div><!-- /.row-->




            <div class="wizard-cotroles">
              <div class="control next" data-target="tab-5" (click)="openNext(3)">Next</div>
              <p>3 Of 5</p>
              <div class="control prev" data-target="tab-2" (click)="openPrevious(1)">Prev</div>
            </div> <!-- /.wizard-cotroles -->

          </div> <!-- /.tabpanel -->




        </p-tabPanel>
        <p-tabPanel header="Comments" leftIcon="pi pi-user">
          <div role="tabpanel" class="tab-pane " id="tab-5">
            <div class="card">
              <div class="card-title">
                <h2>Latest Comments</h2>
              </div>
              <div class="cont">
                <ul class="latest-comments" id="userComments">
                  <li *ngFor="let comment of userCommentsList; let i = index">
                    <div class="cont-img"><img src="" alt=""></div>
                    <div class="cont-txt">
                      <h3>{{comment?.user?.firstName + " " + comment?.user?.lastName}}</h3>
                      <h4>{{comment?.title}}</h4>
                      <p>{{comment?.text}}</p>
                      <span class="date">{{comment?.createDate | date:'medium'}}</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card">
              <div class="card-title">
                <h2>Add comment</h2>
              </div>
              <div class="cont">
                <div class="add-comment">
                  <div class="form-group">
                    <div class="inputs" id="addComment">
                      <input type="text" id="commentTitle" placeholder="Comment Title">
                      <textarea name="" id="commentText" cols="30" rows="10" placeholder="Comment Details"></textarea>
                    </div><!-- /.inputs -->
                  </div>
                  <div class="form-actions">
                    <button id="post">Post</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="wizard-cotroles">
              <!-- <div class="control next" id="submit" (click)="onSubmitClicked($event);" >Finish</div>-->
              <div class="form-actions">
                <button id="finish">Finish</button>
              </div>

              <p>4 Of 5</p>
              <div class="control prev" data-target="tab-3" (click)="openPrevious(2)">Prev</div>
            </div>
          </div>
        </p-tabPanel>

        <p-tabPanel header="History" leftIcon="fa fa-history" *ngIf="editOpportunityId!=-1">
          <div role="tabpanel" class="tab-pane " id="tab-6">
            <app-history [hideComponent]="true"></app-history>
            <div class="wizard-cotroles">
              <!-- <div class="control next" id="submit" (click)="onSubmitClicked($event);" >Finish</div>-->
              <p>5 Of 5</p>
              <div class="control prev" data-target="tab-3" (click)="openPrevious(3)">Prev</div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </section>
</form>


<p-dialog [(visible)]="productDialog" [style]="{ width: '45%' }" header="Item Form" [modal]="true" styleClass="p-fluid">
  <div class="p-grid ui-fluid" *ngIf="product">
    <div class="form-group">
      <!-- Category Dropdown -->

      <app-products-lists [kind]="getKind()" [(selectedCategory)]="selectedCategory" [(selectedType)]="selectedType"
        [(selectedItem)]="selectedItem" [(selectedProductId)]="selectedProductId"
        (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>


      <br />

      <!-- Price Input -->
      <label for="orderPrice">Price</label>
      <!-- <p-inputNumbe [ngModelOptions]="{ standalone: true }" type="numeric"  id="orderPrice"
        [(ngModel)]="product.orderPrice" required  class="full-width" /> -->
      <p-inputNumber [ngModelOptions]="{ standalone: true }" type="numeric" id="orderPrice"
        [(ngModel)]="product.orderPrice" required class="full-width">
      </p-inputNumber>
      <small class="p-invalid" *ngIf="submitted && !product.orderPrice">
        Price is required.
      </small>
    </div>
    <br />
    <div style="float: right;" class="">
      <div class="options">
        <button (click)="hideDialog()" value="cancel" style="margin-right: 5px;" class="btn">
          <i class="fas fa-times"></i> Cancel
        </button>
        <button value="add" class="btn btn-primary" (click)="saveProduct()"
          [disabled]="selectedProductId == null || product.orderPrice == null">
          <i class="fas fa-check"></i> Save
        </button>
      </div>
      <!-- /.otions -->
    </div>
  </div>
</p-dialog>